import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

/**
 * RBAC route koruması. Yalnızca izin verilen rollerdeki kullanıcılar erişebilir;
 * diğerleri dashboard'a yönlendirilir.
 * Kullanım: <RoleRoute roles={["ADMIN"]}><AdminPage/></RoleRoute>
 */
export default function RoleRoute({ roles, children }) {
  const user = useSelector((state) => state.auth.user);
  return roles.includes(user?.role) ? children : <Navigate to="/dashboard" replace />;
}
